const e = [
  "add-new",
  "add-reaction",
  "add-to-report",
  "admin-shield-safe",
  "alias-alt",
  "amazon-sagemaker",
  "apps",
  "area",
  "artifact-type",
  "artifact-type-alt",
  "attachment",
  "audio-volume",
  "auto-generate-panels",
  "automation-robot-arm",
  "back",
  "baseline-alt",
  "bell-notifications",
  "benchmark-square",
  "blockquote",
  "blog-alt",
  "blog-report",
  "bold",
  "book-dictionary",
  "bookmark-my-projects",
  "box-plot",
  "branch-commit",
  "bug",
  "bulk-panel",
  "bulk-panel-alt",
  "camera-photo",
  "caret-close",
  "caret-open",
  "category-multimodal",
  "chart-area-alt2",
  "chart-area-percentage",
  "chart-horizontal-bars",
  "chart-line",
  "chart-pie",
  "chart-scatterplot",
  "chart-vertical-bars",
  "checkmark",
  "checkmark-alt",
  "checkmark-circle",
  "checkmark-square",
  "chevron-back",
  "chevron-down",
  "chevron-next",
  "chevron-up",
  "circle",
  "close",
  "cloud",
  "code-alt",
  "collapse",
  "color",
  "column",
  "column-alt",
  "combine",
  "compass-baseline",
  "compass-baseline-alt",
  "condition",
  "content-full-width",
  "content-narrow",
  "content-wide",
  "copy",
  "cost",
  "credit-card-payment",
  "crop-beginning",
  "crop-end",
  "crop-middle",
  "cross",
  "crown-pro",
  "cube-container",
  "dashboard-blackboard",
  "database-artifacts",
  "date",
  "delete",
  "desktop-responsive",
  "diamond",
  "diamond-pro",
  "discord-social",
  "do-not-prohibited",
  "doc-left",
  "docker-whale",
  "document",
  "documentation",
  "download",
  "draft",
  "drag-grip",
  "education-academic",
  "ema-exponential",
  "email-at",
  "email-envelope",
  "enter-return",
  "enter-switch",
  "enterprise-corporate",
  "expand-down",
  "expand-left",
  "expand-right",
  "expand-uncollapse",
  "expand-up",
  "export-share-upload",
  "extract",
  "extract-break",
  "facebook-social",
  "failed-error-deleted",
  "feather",
  "feather-alt",
  "filter-alt",
  "flash-bolt",
  "folder-project",
  "folder-project-move",
  "forum-chat-bubble",
  "forward-next",
  "freeze-snowflake",
  "freeze-workspace",
  "full-screen-mode-expand",
  "ghost-agent",
  "git",
  "github",
  "group",
  "hand-manual",
  "hashtag",
  "headset",
  "heart",
  "help-alt",
  "help-resources",
  "history",
  "home",
  "idle",
  "ignore-outliers",
  "impersonate-mask",
  "impersonate-mask-alt",
  "import-insert",
  "infinity-auto",
  "info",
  "isolate",
  "italic",
  "job-automation",
  "job-calculator",
  "job-program-code",
  "key-admin",
  "key-admin-private",
  "kubernetes",
  "languages",
  "laptop-local-computer",
  "layout-_mixed",
  "layout-grid",
  "layout-horizontal",
  "layout-split",
  "layout-tabs",
  "layout-vertical",
  "lightboard",
  "lightbulb-info",
  "line-plot",
  "line-plot-1",
  "line-plot-alt2",
  "linear-scale",
  "linear-scale-1",
  "link-alt",
  "linkedin-social",
  "list",
  "list-bullets",
  "list-numbered",
  "listing",
  "loading",
  "location-pin",
  "lock-closed",
  "lock-open",
  "locked-constrained",
  "loess",
  "log-in",
  "log-out",
  "log-scale-x",
  "log-scale-y",
  "logarithmic",
  "magic-wand-star",
  "magic-wand-stick",
  "marker",
  "megaphone",
  "menu",
  "microphone-audio",
  "miller-columns",
  "minimize-mode",
  "mobile-responsive",
  "model",
  "multi-select",
  "music-audio",
  "new-section-above",
  "new-section-below",
  "open-new-tab",
  "orchestration-launch",
  "organization-corporate",
  "overflow-horizontal",
  "pan-tool",
  "pan-tool-1",
  "panel",
  "panel-auto-add",
  "panel-freeze-layout",
  "parent-back-up",
  "pause",
  "paused",
  "pencil-edit",
  "phone",
  "photo-picture",
  "play",
  "privacy-open",
  "privacy-team-private",
  "privacy-team-public",
  "privacy-user-private",
  "privacy-user-public",
  "queue",
  "queued",
  "quickstart-code",
  "randomize-alt-reload",
  "randomize-reset-reload",
  "recent-clock",
  "reddit-social",
  "redo",
  "regex",
  "registries",
  "remove",
  "remove-alt",
  "report",
  "retry-swap",
  "robot-service-member",
  "rocket-launch",
  "rowheightL",
  "rowheightM",
  "rowheightS",
  "rowheightXL",
  "run-set-subset",
  "run-set-universe",
  "running-repeat",
  "sandobx-playground",
  "save",
  "scale_up",
  "search",
  "seed-propagate",
  "select-marquee-tool",
  "select-move-tool",
  "settings",
  "settings-parameters",
  "share-with",
  "shield-protected",
  "shield-remove",
  "smoothing",
  "sort",
  "sort-ascending",
  "sort-descending",
  "sort-direction",
  "split",
  "square",
  "stop",
  "stopped",
  "strikethrough",
  "sweep-bayes",
  "sweep-grid",
  "sweep-random-search",
  "sweeps-alt",
  "sweeps-broom",
  "switch-account",
  "system",
  "system-chip",
  "system-chip-alt",
  "table",
  "tablet-responsive",
  "tag",
  "text-language",
  "text-language-alt",
  "thumbs-down",
  "thumbs-up",
  "time-weighted-ema",
  "token",
  "treeview",
  "triangle-down",
  "triangle-left",
  "triangle-right",
  "triangle-up",
  "type-boolean",
  "type-number",
  "type-string-quote",
  "undo",
  "unlocked-unconstrained",
  "up-post",
  "user-author",
  "user-profile-personal",
  "users-team",
  "uuid-identifier",
  "versions-layers",
  "vertex-gcp",
  "video-play",
  "view-alt",
  "view-glasses",
  "wandb",
  "warning",
  "weave",
  "weave-group-board",
  "webhook",
  "webhook-alt",
  "x-axi-alt",
  "x-axis",
  "x-social",
  "youtube-social",
  "zoom-alt-tool",
  "zoom-in-tool",
  "zoom-out-tool"
];
export {
  e as ICONS
};
//# sourceMappingURL=constants.js.map
